import registerWithErrorBoundary from '@utils/registerWithErrorBoundary';

import About from '@components/pages/About/index';

registerWithErrorBoundary({
  About,
});

